module.exports = __webpack_public_path__ + "static/ststephens-dc1bd2a3b6c58404b4a4cd637026fe42.webp";